import api from '@/helpers/api'

const API_READ = `/api/dashboard/summary/`

export default {
  namespaced: true,
  state: {
    status: '',
    dashboards: {},
  },
  mutations: {
    request(state) {
      state.status = 'loading'
    },
    read(state, { dashboards }) {
      state.dashboards = { ...dashboards }
    },
    error(state) {
      state.status = 'error'
    },
    success(state) {
      state.status = 'success'
    },
    clearData(state) {
      state.dashboards = {}
      state.status = 'success'
    },
    switch_page(state, { meta }) {
      state.meta = { ...meta }
    }
  },
  actions: {
    read({ commit }, data) {
      commit('request');

      // Only include filter if data has properties
      const params = {};
      if (data && Object.keys(data).length > 0) {
        params.filter = { ...data };
      }

      return new Promise((resolve, reject) => {
        api.request('get', API_READ, params)
          .then((result) => {
            // console.log('api', result.data.data);
            commit('read', { dashboards: result.data.data })
            commit('success')
            commit('switch_page', { meta: { ...result.data.meta } })
            resolve()
          })
          .catch((err) => {
            commit('error')
            reject(err)
          });
      })
    },
  },
  getters: {
    dashboards: state => state.dashboards,
  }
}